class NativeNotification {
  constructor(notificationId) {
    this.notificationId = notificationId
    this.isActive = false
    this.title = 'Dodo'
  }

  init() {
    if (!isCordova) return

    document.addEventListener('deviceready', () => {
      this.requestPermission()
    })
  }

  requestPermission() {
    if (!isCordova) return

    if (cordova.plugins && cordova.plugins.notification) {
      cordova.plugins.notification.registerPermission()
    }
  }

  setTitle(newTitle) {
    this.title = newTitle
  }

  show(text = null) {
    if (text) this.text = text

    if (!isCordova) {
      return
    }

    return // Disabling notifications because it is just annoying

    const notification = {
      id: this.notificationId,
      title: this.title,
      text: this.text,
      androidChannelId: 'dodo_channel',
      androidOngoing: true,
      androidAutoCancel: false,
      // androidSmallIcon: 'res://dodo-white'
      androidSmallIcon: 'res://ic_launcher'
    }

    if (this.alreadyCreated) {
      let updateResult = cordova.plugins.notification.local.update(notification)
    } else {
      let scheduleResult =
        cordova.plugins.notification.local.schedule(notification)
      this.alreadyCreated = true
    }

    this.isActive = true
  }

  hide() {
    if (!isCordova) return

    cordova.plugins.notification.local.cancel(this.notificationId)
    this.isActive = false
  }

  update(text) {
    if (!isCordova) return

    if (this.isActive) {
      this.show(text) // Just recreate with new text
    }
  }
}

export default NativeNotification

// androidAlarmType: exports._androidAlarmTypes.RTC_WAKEUP,
// // Alarm will be allowed to execute even when the system is in low-power idle (a.k.a. doze) modes.
// androidAllowWhileIdle: false,
// // Make this notification automatically dismissed when the user touches it
// androidAutoCancel : true,
// androidChannelEnableLights: false,
// androidChannelDescription: null,
// androidChannelEnableVibration: false,
// androidChannelId: "default_channel",
// androidChannelImportance: exports._androidChannelImportanceTypes.IMPORTANCE_DEFAULT,
// androidChannelName: "Default channel",
// // soundUsage of a channel. Default is USAGE_NOTIFICATION
// androidChannelSoundUsage: 5,
// // The notification background color for the small icon
// androidColor: null,
// // Android 7 only: Sets the default notification options
// androidDefaults: 0,
// androidGroup: null,
// androidGroupSummary: false,
// androidMessages: null,
// androidLargeIcon : null,
// // Can be square or circle
// androidLargeIconType: "square",
// androidLockscreen: true,
// androidOngoing: false,
// androidOnlyAlertOnce: false,
// androidProgressBar: null,
// // If the Notification should show the when date
// androidShowWhen: true,
// androidSmallIcon: 'res://ic_popup_reminder',
// androidSummary: null,
// // Specifies a duration in milliseconds after which this notification should be canceled,
// // if it is not already canceled.
// androidTimeoutAfter: 0,
// androidTitleCount: "%n%",
// // Show the Notification#when field as a stopwatch. Instead of presenting when as a timestamp,
// // the notification will show an automatically updating display of the minutes and seconds since when
// androidUsesChronometer: false,
// androidWakeUpScreen: true,
// // Overwrites default
// // Increments the badge by the specified number for that notification
// badgeNumber: 1,
// // Only for Android 7
// led: false
